import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import { useLocation } from 'react-router-dom';
import { fetchAnnouncementsAction } from '../../reducers/annoucement';
import { isTechnicianOrAdmin } from '../../helpers';
import announcementVisibilities from '../../constants/announcementVisibilities';
import StickyAlert from '../StickyAlert';

const AnnouncementContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const announcements = useSelector(state =>
    state.announcement.announcements.filter(a => !!a.body)
  );
  const currentUser = useSelector(state => state.auth.user);

  useEffect(() => {
    dispatch(fetchAnnouncementsAction());
  }, [dispatch]);

  if (
    announcements.length === 0 ||
    !['/patients', '/patients-page'].includes(_get(location, 'pathname'))
  ) {
    return null;
  }

  const filterAnnouncement = announcement => {
    if (!currentUser) {
      return false;
    }

    if (
      isTechnicianOrAdmin(currentUser) &&
      announcement.visibility === announcementVisibilities.DOCTOR
    ) {
      return false;
    }

    return true;
  };

  const messages = announcements.filter(filterAnnouncement).map(announcement => ({
    id: announcement.id,
    message: announcement.body
  }));

  return <StickyAlert title="Announcement" messages={messages} />;
};

export default AnnouncementContainer;
